import React from 'react';
import {
  Sector,
} from 'recharts';
import PropTypes from 'prop-types';
import { useSelectedIndex } from 'Packages/FacetDesign/Components/Experimental/PieChart/selectedIndexContext';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

// Adapted from https://recharts.org/en-US/examples/CustomActiveShapePieChart
export const PieChartShape = (props) => {
  const {
    cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, 'data-recharts-item-index': myIndex,
  } = props;
  const { selectedIndex } = useSelectedIndex();
  const selected = myIndex === selectedIndex;
  const theme = useTheme();

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
        strokeWidth={1}
        stroke={theme.palette.common.white}
      />
      {selected ? (
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
      ) : null}
    </g>
  );
};

PieChartShape.defaultProps = {
  innerRadius: undefined,
  outerRadius: '100%',
  startAngle: 0,
  endAngle: 100,
  fill: undefined,
};


PieChartShape.propTypes = {
  cx: PropTypes.string.isRequired,
  cy: PropTypes.string.isRequired,
  innerRadius: PropTypes.string,
  outerRadius: PropTypes.string,
  startAngle: PropTypes.number,
  endAngle: PropTypes.number,
  fill: PropTypes.string,
};
